import React from "react";
import { Grid } from "@material-ui/core";
import numeral from "numeral";
import "./styles.css";

const Step = ({ label, sublabel, details, footer, companyPrimaryColor }) => (
  <Grid container item direction="column" xs={4} className="breakeven-analysis-wrapper">
    <Grid item><div className="breakeven-analysis-step-base breakeven-analysis-step-large">{label}</div></Grid>
    <Grid item><div className="breakeven-analysis-step-base breakeven-analysis-step-medium">{sublabel}</div></Grid>
    <Grid item><div className="breakeven-analysis-step-base breakeven-analysis-step-small">{details()}</div></Grid>
    <Grid item><div className="breakeven-analysis-footer" style={{ color: companyPrimaryColor }}>{footer}</div></Grid>
  </Grid>
);

const BreakevenAnalysis = ({ pv01, treasury, companyPrimaryColor }) => {
  const StepContent = [
    {
      label: "Step One",
      sublabel: "Calculate the effect of each Basis Point on a New Financing",
      details: () => <div>As rates move up or down by 0.01%, the Present Value of the interest increases or decreases by this dollar amount.</div>,
      footer: `PV of 1 Basis Point = ${numeral(pv01).format("$0,0")}`
    },
    {
      label: "Step Two",
      sublabel: "Translate the Net Cost to Refinance into the Rate",
      details: () => <div>
        We can translate this dollar figure into the rate on the new financing with the
        <strong>net cost to refi</strong>
        {" "}
        and the
        <strong>PV01</strong>
        .
      </div>,
      footer: "Inc. to Fixed Coupon = 0.15%"
    },
    {
      label: "Step Three",
      sublabel: "What is the implied 10 Year Treasury Rate at Maturity?",
      details: () => <div>If borrowing spreads remain the same, the implied 10T from this increase gives you the breakeven comparison point.</div>,
      footer: `Implied 10T = ${numeral(treasury / 100).format("0.00%")}`
    }
  ];

  return (
    <Grid container item direction="row" xs={11}>
      <Grid item xs={12}><div className="breakeven-analysis-title" style={{ borderBottom: `1px dashed ${companyPrimaryColor}` }}>Breakeven Analysis</div></Grid>
      <Grid container item xs={12} direction="row" className="breakeven-analysis-wrapper">
        {StepContent.map((sc, idx) => <Step key={idx} {...sc} companyPrimaryColor={companyPrimaryColor} />)}
      </Grid>
    </Grid>
  );
};

export default BreakevenAnalysis;
